module.exports = __webpack_public_path__ + "img/vertical_7_3_6005.bab93056.png";